import styled from 'styled-components';

import { CircularProgress } from '@mui/material';

export const TrackCircularProgress = styled(CircularProgress)`
    position: absolute !important;
    left: 0;
    top: 0;
    color: #eceff3 !important; /* trilha cinza clara */

    .MuiCircularProgress-circle {
        stroke-linecap: round;
    }
`;

export const StyledCircularProgress = styled(CircularProgress)`
    color: #5e8e88 !important; /* barra verde */

    .MuiCircularProgress-circle {
        stroke-linecap: round; /* pontas arredondadas */
    }
`;
